class ItemEditor {
    constructor($http, $scope, toastr, Upload) {
        this.$http = $http;
        this.$scope = $scope;
        this.toastr = toastr;
        this.Upload = Upload;
        this.item = {};
    }

    get(id) {
        this.$http({
            url: "/api/items/" + id,
            method: "get"
        }).then((resp) => {
            console.log(resp);
                if (!resp.error) {
                    this.item = resp.data;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    save() {
        this.$http({
            url: "/api/items/save",
            method: "post",
            data: $.param({
                item: JSON.stringify(this.item)
            }),
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then((resp) => {
            console.log(resp);
            this.item = resp.data;
            this.toastr.success("Успешно сохранено!");
        }, (err) => {
            console.log(err);
        });
    }

    upload(file) {
        if (file) {
            this.Upload.upload({
                url: '/api/upload',
                data: {file: file}
            }).then((resp) => {
                console.log('Success! Response: ');
                console.log(resp.data);
                this.item.Icon = resp.data.icon;
            }, (resp) => {
                console.log('Error status: ' + resp.status);
            }, (evt) => {
                let progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });

        }
    }
}

ItemEditor.$inject = ['$http', '$scope', 'toastr', 'Upload'];

export {ItemEditor};